module.exports = __webpack_public_path__ + "img/spitter-run-1.e20a6e08.png";